/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-07 11:18:19
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-09-08 13:40:23
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/api/tool.js
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'

// 根据会议 code 生成微信二维码
export function createQrcode(data) {
  return request({
    url: '/user/admin/common/generateQRCode',
    method: 'POST',
    data,
  })
}

// 截图接口
export function shotPro(data) {
  return request({
    url: '/user/tools/shotPro',
    method: 'POST',
    data,
  })
}

// 根据 sence 生成短链接
export function createShortLink(data) {
  return request({
    url: '/user/admin/common/getCode',
    method: 'POST',
    data,
  })
}

// 海报生成
export function createPoster(data) {
  return request({
    url: '/poster/tools/shot',
    method: 'POST',
    data,
  })
}
